import { render, staticRenderFns } from "./PurchasesOrderViewLogs.vue?vue&type=template&id=634c6f61"
import script from "./PurchasesOrderViewLogs.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports